import { integrateRouter } from '@ms/utils/trace.js'
import '@ms/plugins/storage.js'
import 'composables/installCompositionApi.js'
import 'wap/common/core'
import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { setVisited } from '@ms/utils-es/visited'
import { setChannel } from '@ms/utils/channel'
import { useAuthStore } from '@ms/stores/auth'
import { trackUserId } from '@ms/utils/track'
import { REGION } from '@ms/config/app'

const NotFound = () => import(/* webpackChunkName: 'notfound' */ 'wap/components/NotFound.vue')

Vue.use(PiniaVuePlugin)
Vue.prototype.$region = REGION

const pinia = createPinia()

/**
 * 创建 vue app 实例
 * @param {VueComponent} App
 * @param {Object} options   vue options 选型参数
 * @returns Vue Instance  返回 vue 实例对象
 */
const createApp = (App, { router, include, exclude, ...rest } = {}, el = '#app') => {
  const notValid = (!!include && !include.includes(REGION)) || (!!exclude && exclude.includes(REGION))
  if (notValid) {
    return new Vue({
      render: (h) => h(NotFound)
    }).$mount(el)
  }

  const options = {
    i18n,
    ...rest,
    pinia,
    render: (h) => h(App),
    beforeCreate() {
      setChannel()
    },
    created() {
      setVisited()
      if (useAuthStore().loginStatus) {
        trackUserId()
      }
      if (REGION === 'gh') {
        if (/kyc=noskip/.test(location.href)) {
          sessionStorage.setItem('kyc', 'noskip')
        } else if (/kyc=hide/.test(location.href)) {
          sessionStorage.setItem('kyc', 'hide')
        }
      }
    }
  }

  if (router) {
    options.router = router
    integrateRouter(router)
  }

  return new Vue(options).$mount(el)
}

export default createApp
